import { render, staticRenderFns } from "./universalDialog(v1.2).vue?vue&type=template&id=8c403eca"
import script from "./universalDialog(v1.2).vue?vue&type=script&lang=js"
export * from "./universalDialog(v1.2).vue?vue&type=script&lang=js"
import style0 from "./universalDialog(v1.2).vue?vue&type=style&index=0&id=8c403eca&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports